import { useState } from "react";
import { Button, Modal, SelectPicker, Table } from "rsuite";
import { ApiAppointment } from "../core/apis";
import {
  ActionsAppointmentTable,
  useAppDispatch,
  useAppSelector,
} from "../core/redux";
import { ApiSchemaAppointment } from "../models/api";
import { AlertDialogProps } from "./alertDialog";

const { Cell } = Table;

type TableData = ApiSchemaAppointment & {
  sl: number;
  checked?: boolean;
};

export const AppointmentStatusCell = ({
  rowData,
  dataKey,
  alertDialog,
  ...props
}: {
  rowData?: TableData;
  dataKey?: keyof TableData;
  alertDialog: {
    open: (props: AlertDialogProps) => void;
    close: Function;
  };
}) => {
  const appointmentStatus = [
    "NotAccepted",
    "Upcoming",
    "Ongoing",
    "Complete",
  ].map((status) => ({
    label: status,
    value: status,
  }));

  const requestedCaregivers =
    rowData?.requestedCaregivers?.map((caregiver) => ({
      label: caregiver.name,
      value: caregiver.skey,
    })) ?? [];

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const [selectedCaregiver, setSelectedCaregiver] = useState<string>();
  const { isLoading } = useAppSelector((state) => state.appointmentTable);
  const [selectedStatus, setSelectedStatus] = useState<string>(
    rowData?.status || ""
  );

  const disabledStatusItems = () => {
    let disabledIT: string[] = [];
    if (rowData && rowData.status === "NotAccepted") {
      disabledIT = appointmentStatus
        .filter((item) => item.value !== "Upcoming")
        .map((item) => item.value);
    }
    if (rowData && rowData.status === "Ongoing") {
      disabledIT = appointmentStatus
        .filter((item) => item.value !== "Complete")
        .map((item) => item.value);
    }
    return disabledIT;
  };

  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    dispatch(ActionsAppointmentTable.setIsLoading(true));
    const caregiverSkey = selectedCaregiver ?? rowData?.caregiverSKey;
    const response = await ApiAppointment.ChangeAppointmentStatus(
      rowData!,
      selectedStatus,
      caregiverSkey
    );
    if (response?.isSuccess) {
      dispatch(ActionsAppointmentTable.setRefetch(true));
    }
    dispatch(ActionsAppointmentTable.setIsLoading(false));
    handleClose();
  };
  return (
    <>
      <Cell {...props} className="appointmentStatusCell">
        {rowData && dataKey && (
          <SelectPicker
            data={appointmentStatus}
            value={rowData.status}
            searchable={false}
            onChange={(value: any) => {
              if (rowData.status !== value) {
                handleOpen();
                setSelectedStatus(value);
              }
            }}
            className="w-100"
            size="sm"
            cleanable={false}
            disabled={
              rowData.status === "Complete" || rowData.status === "Upcoming"
            }
            disabledItemValues={disabledStatusItems()}
          />
        )}
      </Cell>
      <Modal open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {rowData && rowData.status === "NotAccepted" && (
            <div className="row">
              <label>Select Caregiver:</label>
              <SelectPicker
                data={requestedCaregivers ?? []}
                value={selectedCaregiver}
                searchable={false}
                onChange={(value: any) => setSelectedCaregiver(value)}
                className="w-100"
                size="sm"
                cleanable={false}
              />
            </div>
          )}
          <div className="my-2">
            <p>
              Are you sure you want to change the status of this appointment?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            loading={isLoading}
            appearance="primary"
            onClick={handleSubmit}
            disabled={
              rowData && rowData.status === "NotAccepted" && !selectedCaregiver
            }
          >
            Change
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            type="reset"
            appearance="subtle"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
